import { render } from "./Womens.vue?vue&type=template&id=939f5520"
import script from "./Womens.vue?vue&type=script&lang=js"
export * from "./Womens.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__